import styled from "styled-components";

const DownloadContainer = styled.div`
  filter: drop-shadow(rgba(0, 0, 0, 0.1) 0px 2px 4px);
  border-radius: 12px;
`;

const Div = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 6px 6px 0px 0px;
`;

const DivDownload = styled.div`
  background: rgb(250, 250, 250);
  border-radius: 0px 0px 6px 6px;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: rgb(242, 169, 0);
`;

const CardDownload = (props) => {
  return (
    <DownloadContainer className="mb-4">
      <Div className="p-3">
        <p className="m-0">{props.text}</p>
      </Div>
      <DivDownload className="d-flex justify-content-between align-items-center p-3">
        <Text>Download</Text>
        <a href={props.link} target="blank">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#F2A900"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.434 9.834L12.8 12.47V4h-1.6v8.469L8.566 9.834l-1.132 1.132L12 15.53l4.566-4.565-1.132-1.132zM20 18.4v-3.2h-1.6v3.2H5.6v-3.2H4v3.2A1.6 1.6 0 005.6 20h12.8a1.6 1.6 0 001.6-1.6z"
            ></path>
          </svg>
        </a>
      </DivDownload>
    </DownloadContainer>
  );
};

export default CardDownload;
